export default "__VITE_PUBLIC_ASSET__a7023ab3__"